import api from './api';

export const LocumsAPI = {
  getAll: (params = {}) => api.get('/locums', { params }),
  getOne: (id) => api.get(`/locums/${id}`),
  verify: (id) => api.patch(`/locums/${id}/verify`),
};